const NS = 'CourseHeroBlock';
const CLS = 'courseHeroBlock';

import { animateScrollRevealMixinBlock } from '../../mixins/animateScrollRevealMixinBlock/animateScrollRevealMixinBlock';
import { gsap } from 'gsap/dist/gsap';

export class CourseHeroBlock {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.$tplScroller = $('.tpl-scroller');
		this.$scrollToButton = this.$element.find(`.${CLS}-scrollTo`);

		this.initAnimateScrollReveal(this, CLS);

		// Scroll to next block (with top margin and nav bar offset included)
		this.$scrollToButton.on('click', () => {
			const elOffsetTop = $(this.$element.next()).offset().top; // block y pos
			const elMarginTop = parseInt($(this.$element.next()).css('margin-top')); // block margin top
			const targetY = elOffsetTop - elMarginTop - 60; // minus nav height
			// console.log(elOffsetTop, elMarginTop, targetY);
			gsap.to(this.$tplScroller[0], {
				scrollTo: targetY,
				duration: 0.75
			});
		});
	}
}

Object.assign(CourseHeroBlock.prototype, animateScrollRevealMixinBlock);
